import * as i0 from '@angular/core';
import { input, booleanAttribute, signal, computed, Directive } from '@angular/core';
import { BaseModelHolder } from 'primeng/basemodelholder';
let BaseEditableHolder = /*#__PURE__*/(() => {
  class BaseEditableHolder extends BaseModelHolder {
    /**
     * There must be a value (if set).
     * @defaultValue false
     * @group Props
     */
    required = input(undefined, {
      ...(ngDevMode ? {
        debugName: "required"
      } : {}),
      transform: booleanAttribute
    });
    /**
     * When present, it specifies that the component should have invalid state style.
     * @defaultValue false
     * @group Props
     */
    invalid = input(undefined, {
      ...(ngDevMode ? {
        debugName: "invalid"
      } : {}),
      transform: booleanAttribute
    });
    /**
     * When present, it specifies that the component should have disabled state style.
     * @defaultValue false
     * @group Props
     */
    disabled = input(undefined, {
      ...(ngDevMode ? {
        debugName: "disabled"
      } : {}),
      transform: booleanAttribute
    });
    /**
     * When present, it specifies that the name of the input.
     * @defaultValue undefined
     * @group Props
     */
    name = input(...(ngDevMode ? [undefined, {
      debugName: "name"
    }] : []));
    _disabled = signal(false, ...(ngDevMode ? [{
      debugName: "_disabled"
    }] : []));
    $disabled = computed(() => this.disabled() || this._disabled(), ...(ngDevMode ? [{
      debugName: "$disabled"
    }] : []));
    onModelChange = () => {};
    onModelTouched = () => {};
    writeDisabledState(value) {
      this._disabled.set(value);
    }
    writeControlValue(value, setModelValue) {
      // NOOP - this method should be overridden in the derived classes
    }
    /**** Angular ControlValueAccessors ****/
    writeValue(value) {
      this.writeControlValue(value, this.writeModelValue.bind(this));
    }
    registerOnChange(fn) {
      this.onModelChange = fn;
    }
    registerOnTouched(fn) {
      this.onModelTouched = fn;
    }
    setDisabledState(val) {
      this.writeDisabledState(val);
      this.cd.markForCheck();
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵBaseEditableHolder_BaseFactory;
      return function BaseEditableHolder_Factory(__ngFactoryType__) {
        return (ɵBaseEditableHolder_BaseFactory || (ɵBaseEditableHolder_BaseFactory = i0.ɵɵgetInheritedFactory(BaseEditableHolder)))(__ngFactoryType__ || BaseEditableHolder);
      };
    })();
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: BaseEditableHolder,
      inputs: {
        required: [1, "required"],
        invalid: [1, "invalid"],
        disabled: [1, "disabled"],
        name: [1, "name"]
      },
      features: [i0.ɵɵInheritDefinitionFeature]
    });
  }
  return BaseEditableHolder;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { BaseEditableHolder };
